import { supabase } from '@/lib/supabase'
import type { RewardsAccountExchangeLink, RewardsExchange } from '../types'
import { getAccountIdForUser } from './rewardsAccountService'

export async function listRewardsLinksForUser(userId: string): Promise<{ accountId: string | null; links: RewardsAccountExchangeLink[] }> {
  const accountId = await getAccountIdForUser(userId)
  if (!accountId) return { accountId: null, links: [] }

  const { data, error } = await supabase
    .from('rewards_account_exchange_links')
    .select('id,account_id,exchange,exchange_user_id,status,linked_at,last_sync_at,last_error,created_at,updated_at')
    .eq('account_id', accountId)
    .order('exchange', { ascending: true })
  if (error) throw error

  return { accountId, links: ((data || []) as any[]).map((r) => ({
    id: r.id,
    account_id: r.account_id,
    exchange: r.exchange,
    exchange_user_id: r.exchange_user_id,
    status: r.status,
    linked_at: r.linked_at || null,
    last_sync_at: r.last_sync_at || null,
    last_error: r.last_error || null,
    created_at: r.created_at,
    updated_at: r.updated_at,
  })) }
}

export async function upsertRewardsLink(params: { exchange: RewardsExchange; exchangeUserId: string }): Promise<RewardsAccountExchangeLink> {
  const { data, error } = await supabase.functions.invoke('rewards-link-account', {
    body: { exchange: params.exchange, exchange_user_id: params.exchangeUserId },
  })
  if (error) throw error
  const payload = Array.isArray(data) ? (data as any)[0] : (data as any)
  if (!payload?.ok) throw new Error(payload?.error || 'Falha ao registrar vinculo')
  const link = payload.link as any
  return {
    id: link.id,
    account_id: link.account_id,
    exchange: link.exchange,
    exchange_user_id: link.exchange_user_id,
    status: link.status,
    linked_at: link.linked_at || null,
    last_sync_at: link.last_sync_at || null,
    last_error: link.last_error || null,
    created_at: link.created_at,
    updated_at: link.updated_at,
  }
}

